import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	XThemeForm,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeRadio,
	XThemeSelect,
	XThemeTag,
	XThemeContainer,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { PlusOutlined, DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
	Radio,
	Input,
	Button,
	Row,
	Col,
	InputNumber,
	notification,
	Card,
	Result,
	Space,
	Grid,
} from 'antd';

import { useNavigate, Link } from 'react-router-dom';
import { getCasesApi, getCasesReset } from '../../actions/getCasesAction';
import {
	caseStatuses,
	dateFilters,
	medicalCoverage,
} from '../../utils/constants';
import {
	toTitleCase,
	checkModulePermissions,
	urlPagination,
	truncateString,
} from '../../utils/helper';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import {
	getHospitalDropdownApi,
	getHospitalDropdownReset,
} from '../../actions/getHospitalDropdownAction';
import { editCaseApi, editCaseReset } from '../../actions/editCaseAction';
import DataTable from '../../components/DataTable/DataTable';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
import { filterByLabel, handleInputChange } from '../../utils/formFunctions';
import Header from '../../components/Header/Header';
import {
	getInsuranceDropdownApi,
	getInsuranceDropdownReset,
} from '../../actions/getInsuranceDropdownAction';
import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';
import { getRegionsApi } from '../../actions/getRegionsAction';
import {
	XTheme2InnerCard,
	XTheme2Para1,
	XThemeDashboardLottieCard,
} from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import DashboardJson from '../../json/Reclaim.json';

const CaseClosure = (props) => {
	const {
		getCases,
		getCasesReset,
		getCasesState,
		editCase,
		editCaseReset,
		editCaseState,
		getStateDropdownState,
		getStateDropdown,
		getHospitalDropdown,
		getHospitalDropdownState,
		getInsuranceDropdown,
		getRegions,
		getRegionsState,
		getOrganizations,
		getOrganizationsState,
	} = props;

	const navigate = useNavigate();
	const defaultFilters = {
		search: '',
		for_page: 'case-analysis',
		page: 1,
		sort: 'createdAt',
		sortDirection: 'descend',
		created_on: 'all',
		hospital: '',
		organization: '',
		region: '',
		state: '',
		status: '',
		insurance_company: '',
		medical_coverage: '',
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [searchOptions, setSearchOptions] = useState([]);
	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();

	const [modalOpen, setModalOpen] = useState([false, '']);
	const [formData, setFormData] = useState({
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
	});
	const [open, setOpen] = useState(false);
	const [insuranceCompanies, setInsuranceCompanies] = useState([]);
	const [pagination, setPagination] = useState(1);

	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('case-analysis').authorized &&
			getCases({ ...updatedFilters, for_page: 'case-analysis' });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	const columns = [
		{
			title: 'Case ID',
			dataIndex: 'case_id',
			fixed: 'left',
			width: 150,
			render: (case_id) => (
				<Link
					style={{ color: '#000', textDecoration: 'underline' }}
					to={`${case_id[2]}/${case_id[0]}`}
				>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{case_id[1]}
					</div>
				</Link>
			),
		},
		{
			title: 'Patient ID',
			dataIndex: 'mrn',
			fixed: 'left',
			width: 150,

			render: (mrnId) => (
				<Link
					style={{ color: '#000', textDecoration: 'underline' }}
					to={`${mrnId[2]}/${mrnId[0]}`}
				>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{mrnId[1]}
					</div>
				</Link>
			),
		},
		{
			title: 'Case Name',
			dataIndex: 'patient_name',
			fixed: 'left',
			width: 200,

			render: (nameId) => (
				<Link
					style={{ color: '#000', textDecoration: 'underline' }}
					to={`${nameId[2]}/${nameId[0]}`}
				>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{truncateString(nameId[1], 25)}
					</div>
				</Link>
			),
		},
		{
			title: 'Insurance Company',
			dataIndex: 'insurance_company',
			width: 300,

			render: (insurance_company) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{insurance_company}
					</div>
				</div>
			),
		},
		{
			title: 'Hospital',

			dataIndex: 'hospital',
			width: 200,

			render: (hospital) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{hospital}
					</div>
				</div>
			),
		},
		{
			title: 'State',
			dataIndex: 'state',
			width: 150,

			render: (state) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{state}
					</div>
				</div>
			),
		},
		{
			title: 'Medicare Coverage',
			dataIndex: 'medical_coverage',
			width: 150,
			render: (medical_coverage) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{medical_coverage}
					</div>
				</div>
			),
		},
		{
			title: 'Allocated to',
			dataIndex: 'allocated',
			width: 150,

			render: (allocated) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{allocated}
					</div>
				</div>
			),
		},
		{
			title: 'Status',
			dataIndex: 'status',
			width: 150,

			render: (status) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{status}
					</div>
				</div>
			),
		},
		// {
		// 	title: 'Deadline Date',
		// 	dataIndex: 'deadline_date',
		// 	width: 150,
		// 	sorter: (a, b) => a.deadline_date - b.deadline_date,
		// 	sortDirections: ['ascend', 'descend'],
		// 	render: (deadline_date) => (
		// 		<div>
		// 			<div
		// 				style={{
		// 					whiteSpace: 'pre-wrap',
		// 					wordWrap: 'break-word',
		// 				}}
		// 			>
		// 				{deadline_date}
		// 			</div>
		// 		</div>
		// 	),
		// },
		{
			title: 'Created On',
			dataIndex: 'createdAt',
			width: 150,

			sorter: (a, b) => a.createdAt - b.createdAt,
			sortDirections: ['ascend', 'descend'],
			render: (createdAt) => (
				<div>
					<div
						style={{
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word',
						}}
					>
						{createdAt}
					</div>
				</div>
			),
		},
	];

	// use effects

	useEffect(() => {
		if (getCasesState.apiState === 'success') {
			if (getCasesState.data.all_cases.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getCasesState.data.total_count);
				getCasesState.data.all_cases.map((item, index) => {
					updatedSearchOptions.push({ value: item.patient_name });
					updatedData.push({
						key: item._id,
						case_id: [item._id, item.case_id, '/case-analysis'],
						mrn: [item._id, item.mrn, '/case-analysis'],
						patient_name: [
							item._id,
							item.patient_name,
							'/case-analysis',
						],
						insurance_company: item.insurance
							? item.insurance.name
							: '-',
						allocated: item.allocated_to ? item.allocated_to : '-',
						hospital: item.hospitals ? item.hospitals.name : '-',
						medical_coverage: item.coverage_feedbacks
							? item.coverage_feedbacks
									?.updated_medical_coverage_applicable ?? '-'
							: '-',
						state: item.state ? item.state : '-',
						allocated: item.allocated_to ? item.allocated_to : '-',
						status: (
							<>
								<XThemeTag className={item.status}>
									{toTitleCase(item.status)}
								</XThemeTag>
							</>
						),
						deadline_date: (
							<div className="showDate">
								{moment(item.deadline_date).format(
									'DD-MM-YYYY',
								)}
							</div>
						),
						createdAt: (
							<div className="showDate">
								{moment(item.createdAt).format('DD-MM-YYYY')}
							</div>
						),

						statusMobile: item.status,
					});
				});
				setSearchOptions(updatedSearchOptions);
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getCasesState]);

	useEffect(() => {
		if (editCaseState.apiState === 'success') {
			editCaseReset();
			setModalOpen([false, '']);
		}
		// else if (editCaseState.apiState === 'error') {
		// 	notification.error({ message: editCaseState.message });
		// }
	}, [editCaseState]);

	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Case Analysis" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile headerTag="caseAnalysis" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions('case-analysis').authorized ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							{/* <Col
								xs={24}
								sm={24}
								md={3}
								lg={2}
								className="text-center"
							>
								<XThemeDashboardLottieCard
									className="caseManagementTitleAnimation"
									animationData={DashboardJson}
									loop={true}
								/>
							</Col> */}
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Case Analysis Management
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage case analysis
								</XTheme2Para1>
							</Col>
						</Row>
						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-md-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="status"
											colon={false}
											label="Status"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="status"
												defaultValue={
													filters.status
														? filters.status
														: null
												}
											>
												<Row>
													{caseStatuses.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="hospital"
											label="Hospital"
											colon={false}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Hospital"
												name="hospital"
												allowClear
												className="noBorderRadius"
												showSearch={true}
												defaultValue={
													filters.hospital
														? filters.hospital
														: null
												}
												onFocus={() => {
													getHospitalDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getHospitalDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getHospitalDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														hospital: '',
													});
												}}
												filterOption={filterByLabel}
												options={
													getHospitalDropdownState.apiState ===
														'success' &&
													getHospitalDropdownState
														.data.hospitals
														?.length > 0 &&
													getHospitalDropdownState.data.hospitals.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value) => {
													setFilters({
														...filters,
														hospital: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="organization"
											label={'Organization'}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Organization"
												name="organization"
												showSearch={true}
												className="noBorderRadius"
												onFocus={() => {
													getOrganizations();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getOrganizations({
															search,
														});
													} else if (
														search.length === 0
													) {
														getOrganizations();
													}
												}}
												// filterOption={filterByLabel}
												options={
													getOrganizationsState.apiState ===
														'success' &&
													getOrganizationsState.data
														.list?.length > 0 &&
													getOrganizationsState.data.list.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														organization: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="region"
											label={'Region'}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Region"
												name="region"
												showSearch={true}
												className="noBorderRadius"
												onFocus={() => {
													getRegions();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getRegions({
															search,
														});
													} else if (
														search.length === 0
													) {
														getRegions();
													}
												}}
												filterOption={filterByLabel}
												options={
													getRegionsState.apiState ===
														'success' &&
													getRegionsState.data.regions
														?.length > 0 &&
													getRegionsState.data.regions.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														region: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="state"
											colon={false}
											label="State"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												className="noBorderRadius"
												placeholder="Select State"
												defaultValue={
													filters.state
														? filters.state
														: null
												}
												onFocus={() => {
													getStateDropdown();
												}}
												// onSearch={(search) => {
												// 	if (search.length >= 3) {
												// 		getStateDropdown({
												// 			search,
												// 		});
												// 	} else if (search.length === 0) {
												// 		getStateDropdown();
												// 	}
												// }}
												onClear={() => {
													setFilters({
														...filters,
														state: '',
														insurance_company: '',
													});
													form2.setFieldValue(
														'insurance_company',
														'',
													);
													setInsuranceCompanies([]);
												}}
												showSearch={true}
												filterOption={filterByLabel}
												options={
													getStateDropdownState.apiState ===
														'success' &&
													getStateDropdownState.data
														.all_states?.length >
														0 &&
													getStateDropdownState.data.all_states.map(
														(itm) => {
															return {
																label: itm.state,
																value: itm.state,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														state: value,
													});
													setInsuranceCompanies(
														options.providers,
													);
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="insurance_company"
											label="Insurance Company"
											colon={false}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Insurance Company"
												name="insurance_company"
												allowClear
												className="noBorderRadius"
												showSearch={true}
												defaultValue={
													filters.insurance_company
														? filters.insurance_company
														: null
												}
												onFocus={() => {
													getInsuranceDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getInsuranceDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getInsuranceDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														insurance_company: '',
													});
												}}
												filterOption={filterByLabel}
												options={
													insuranceCompanies.length >
														0 &&
													insuranceCompanies.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value) => {
													setFilters({
														...filters,
														insurance_company:
															value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="medical_coverage"
											colon={false}
											label="Medicare Coverage"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="medical_coverage"
												defaultValue={
													filters.medical_coverage
														? filters.medical_coverage
														: null
												}
											>
												<Row>
													{medicalCoverage.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="created_on"
											colon={false}
											label="Date Within"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="created_on"
												defaultValue={
													filters.created_on
														? filters.created_on
														: null
												}
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={18} sm={24} md={6} lg={4}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Cases
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search for Cases"
												defaultValue={
													filters.patient_name
														? filters.patient_name
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														urlPagination(
															filters,
															'patient_name',
															'',
														);
														setFilters({
															...filters,
															patient_name: '',
														});
													} else {
														setFilters({
															...filters,
															patient_name:
																v.target.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.patient_name
																? filters.patient_name
																: '';
														if (searchValue) {
															urlPagination(
																filters,
																'patient_name',
																searchValue,
															);
															setFilters({
																...filters,
																patient_name:
																	searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.patient_name
															? filters.patient_name
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'patient_name',
															searchValue,
														);
														setFilters({
															...filters,
															patient_name:
																searchValue,
														});
													}
												}}
												className="px-4"
												size="large"
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>

									<Col
										xs={6}
										sm={8}
										md={6}
										lg={8}
										className="text-end"
									>
										<Space>
											<XTheme2Button
												className="noBackground borderColor"
												shape="circle"
												size="large"
												onClick={() => showDrawer()}
												icon={
													<img
														src="/images/theme-filter-icon.svg"
														alt="filter"
													/>
												}
											/>
										</Space>
									</Col>
								</Row>
							</div>

							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getCasesState.apiState}
								setPagination={setPagination}
								page={'case'}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getCasesState: state.getCases,
	editCaseState: state.editCase,
	getStateDropdownState: state.getStateDropdown,
	getHospitalDropdownState: state.getHospitalDropdown,
	getInsuranceDropdownState: state.getInsuranceDropdown,
	getRegionsState: state.getRegions,
	getOrganizationsState: state.getOrganizations,
});

const mapDispatchToProps = (dispatch) => ({
	getCases: (data) => dispatch(getCasesApi(data)),
	getCasesReset: () => dispatch(getCasesReset()),
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getHospitalDropdown: (params) => dispatch(getHospitalDropdownApi(params)),
	getHospitalDropdownReset: () => dispatch(getHospitalDropdownReset()),
	getInsuranceDropdown: (params) => dispatch(getInsuranceDropdownApi(params)),
	getInsuranceDropdownReset: () => dispatch(getInsuranceDropdownReset()),
	getRegions: (params) => dispatch(getRegionsApi(params)),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseClosure);
